import React, { lazy } from 'react';
import ProtectedRoute from '../ProtectedRoute';

const Colaboradores = lazy(() => import('../../components/dashboard/TalentoHumano/Colaboradores/Colaboradores'));
const DailyAttendanceReport = lazy(() => import('../../components/dashboard/TalentoHumano/Asistencia/DailyAttendanceReport'));
const WeeklyAttendanceReport = lazy(() => import('../../components/dashboard/TalentoHumano/Asistencia/WeeklyAttendanceReport'));
const ConsolidatedAttendanceReport = lazy(() => import('../../components/dashboard/TalentoHumano/Asistencia/ConsolidatedAttendanceReport'));
const AttendanceControlCenter = lazy(() => import('../../components/dashboard/TalentoHumano/Asistencia/AttendanceControlCenter'));
const EmployeeAbsenceReport = lazy(() => import('../../components/dashboard/TalentoHumano/Asistencia/EmployeeAbsenceReport'));
const AbsenceJustificationManager = lazy(() => import('../../components/dashboard/TalentoHumano/Asistencia/AbsenceJustificationManager'));
const HolidayManager = lazy(() => import('../../components/dashboard/TalentoHumano/Asistencia/HolidayManager'));
const VacacionesManager = lazy(() => import('../../components/dashboard/TalentoHumano/Asistencia/VacacionesManager'));
const BajasPersonal = lazy(() => import('../../components/dashboard/TalentoHumano/Colaboradores/BajasPersonal'));
const MonthlyAdvancedReport = lazy(() => import('../../components/dashboard/TalentoHumano/Asistencia/MonthlyAdvancedReport'));
const AssignedAssets = lazy(() => import('../../components/dashboard/TalentoHumano/Activos/AssignedAssets'));
const PlanillaManager = lazy(() => import('../../components/dashboard/TalentoHumano/Planillas/PlanillaManager'));
const PlanillaDetalle = lazy(() => import('../../components/dashboard/TalentoHumano/Planillas/PlanillaDetalle'));
const ConfiguracionEmpleadoPlanilla = lazy(() => import('../../components/dashboard/TalentoHumano/Planillas/ConfiguracionEmpleadoPlanilla'));
const VariablesMensualesManager = lazy(() => import('../../components/dashboard/TalentoHumano/Planillas/VariablesMensualesManager'));
const DescuentosManager = lazy(() => import('../../components/dashboard/TalentoHumano/Planillas/DescuentosManager'));

const talentoHumanoRoutes = [
  {
    path: 'talento-humano/directorio',
    element: (
      <ProtectedRoute requiredPermission="view_directory">
        <Colaboradores />
      </ProtectedRoute>
    ),
  },
  {
    path: 'talento-humano/activos',
    element: (
      <ProtectedRoute requiredPermission="view_assets">
        <AssignedAssets />
      </ProtectedRoute>
    ),
  },
  {
    path: 'talento-humano/asistencia',
    element: (
      <ProtectedRoute requiredPermission="view_daily_attendance">
        <DailyAttendanceReport />
      </ProtectedRoute>
    ),
  },
  {
    path: 'talento-humano/asistencia-semanal',
    element: (
      <ProtectedRoute requiredPermission="view_weekly_attendance">
        <WeeklyAttendanceReport />
      </ProtectedRoute>
    ),
  },
  {
    path: 'talento-humano/asistencia-consolidado',
    element: (
      <ProtectedRoute requiredPermission="view_consolidated_attendance">
        <ConsolidatedAttendanceReport />
      </ProtectedRoute>
    ),
  },
  {
    path: 'talento-humano/control-en-vivo',
    element: (
      <ProtectedRoute requiredPermission="view_realtime_monitor">
        <AttendanceControlCenter />
      </ProtectedRoute>
    ),
  },
  {
    path: 'talento-humano/ausencias',
    element: (
      <ProtectedRoute requiredPermission="view_absences">
        <EmployeeAbsenceReport />
      </ProtectedRoute>
    ),
  },
  {
    path: 'talento-humano/justificaciones',
    element: (
      <ProtectedRoute requiredPermission="manage_justifications">
        <AbsenceJustificationManager />
      </ProtectedRoute>
    ),
  },
  {
    path: 'talento-humano/vacaciones',
    element: (
      <ProtectedRoute requiredPermission="manage_justifications">
        <VacacionesManager />
      </ProtectedRoute>
    ),
  },
  {
    path: 'talento-humano/dias-festivos',
    element: (
      <ProtectedRoute requiredPermission="manage_holidays">
        <HolidayManager />
      </ProtectedRoute>
    ),
  },
  {
    path: 'talento-humano/bajas',
    element: (
      <ProtectedRoute requiredPermission="manage_exits">
        <BajasPersonal />
      </ProtectedRoute>
    ),
  },
  {
    path: 'talento-humano/reporte-mensual',
    element: (
      <ProtectedRoute requiredPermission="view_monthly_advanced_report">
        <MonthlyAdvancedReport />
      </ProtectedRoute>
    ),
  },
  {
    path: 'talento-humano/planillas',
    element: (
      <ProtectedRoute requiredPermission="view_payrolls">
        <PlanillaManager />
      </ProtectedRoute>
    ),
  },
  {
    path: 'talento-humano/planillas/:planillaId',
    element: (
      <ProtectedRoute requiredPermission="view_payrolls">
        <PlanillaDetalle />
      </ProtectedRoute>
    ),
  },
  {
    path: 'talento-humano/configuracion-planilla',
    element: (
      <ProtectedRoute requiredPermission="manage_payroll_config">
        <ConfiguracionEmpleadoPlanilla />
      </ProtectedRoute>
    ),
  },
  {
    path: 'talento-humano/variables-mensuales',
    element: (
      <ProtectedRoute requiredPermission="manage_monthly_variables">
        <VariablesMensualesManager />
      </ProtectedRoute>
    ),
  },
  {
    path: 'talento-humano/descuentos-personal',
    element: (
      <ProtectedRoute requiredPermission="manage_deductions">
        <DescuentosManager />
      </ProtectedRoute>
    ),
  },
];

export default talentoHumanoRoutes;
